module.exports = __webpack_public_path__ + "assets/media/drag-drop.90021d26.svg";